import { HiverAxios, CHANGE_STEP } from 'h-signup'

const SM_SET_GROUP_TYPE = '/gx/api/sm/setgrouptype';

function setToGroupType(smid, cb) {
    return (dispatch) => {
        HiverAxios({
            url: SM_SET_GROUP_TYPE,
            type: 'post',
            params: { "smid": smid },
            callback: (response) => {
                const { status } = response.data;
                cb(status === "success");
            },
            onfail: () => {
				cb(false);
            }
        });
    };
}

export default setToGroupType